import { breakpoints } from 'hfs-common-ui';
import { css } from 'styled-components';
import { mediaQuery } from './variables';

export interface GridProps {
  $columns?: number;
  /** this is gap unit 1 unit is equal 0.25 rem ( 4px ) */
  $gap?: number;
}

export type ColProps = {
  $span?: number;
  $columns?: number;
  $offset?: number;
  $s?: number;
  $m?: number;
  $l?: number;
  $xl?: number;
  $xxl?: number;
};

const GridCss = css<GridProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${mediaQuery.up.s`
  display: grid;
  /* Defines the number of columns in the grid, defaulting to 12 */
  grid-template-columns: repeat(${({ $columns }) => $columns ?? 12}, minmax(0, 1fr));
  /* Sets the gap between grid items, default is 16px */
  gap: ${({ $gap }) => `${($gap ?? 4) * 0.25}rem`};
  width: 100%;
  `}
`;

const ColCss = css<ColProps>`
  /* Responsive behavior: Adjusts column span on small screens (default fallback) */
  grid-column: span
    ${(props) => Math.min(Math.max(props.$s ?? props.$span ?? 12, 1), props.$columns ?? 12)};

  /* Adds an optional left margin (offset) to shift the column's position */
  ${(props) => props.$offset && `grid-column-start: ${props.$offset + 1};`}

  /* Responsive behavior: Adjusts column span dynamically based on breakpoints */
  ${(props) =>
    Object.keys(breakpoints).map(
      (breakpoint) =>
        props['$' + breakpoint] &&
        mediaQuery.up[breakpoint]`
          grid-column: span ${Math.min(
            Math.max(props['$' + breakpoint] ?? 1, 1),
            props.$columns ?? 12
          )};
        `
    )}
`;

export { ColCss, GridCss };
